import React, {Component} from 'react';
import _, { get, includes, some, split } from 'lodash';
import $ from 'jquery';
import {IReducerState} from '../../../states/renditionStates';
import {connect} from 'react-redux';
import * as asyncStateAction from '../../../actions/asyncStateAction';
import servicesConfig from '../../../services/servicesConfig';
import {checkDomEntitlement} from '../../../utils/general/checkDomEntitlement';
import * as HTML_RENDITION from '../../../utils/general/general';
import UserAgentUtils from '../../../utils/general/userAgentUtils';
import {deviceTypeFunc} from '../../../utils/api/appControl';
import {RenditionLoadable} from '../../../utils/general/LoadableRelated';
import MultiCompanyCatalystWatch from './multiCompanyCatalystWatch';
import CatalystWatch from './catalystWatch';
import BullBear from './bullBear';
import MultiCompanyBullBear from './multiCompanyBullBear';
import FinancialsAndIndustry from './financialsAndIndustry';
import PointFinancialsBlock from './pointFinancialsBlock/pointFinancialsBlock';
import SupplyChain from './supplychain';
import HouseViews from './houseViews';
import StyleAndFactors from './styleAndFactors';
import ReportingCalendar from './reportingCalendar';
import FocusList from './focusList';
import CompanyModel from './companyModel';
import CorporateAccess from './corporateAccess';
import CvMacroTools from './cvmacroTools';
import GlobalThemeMachine from './globalThemeMachine';
import keyResearchChanges from './keyResearchChanges';
import ErrorBoundary from '../../../utils/api/errorBoundary';
import commonStore from '../../../store/commonStore.js';
import CompanyDashboard from './companyDashboard';
import StylesScoreRelativeToPeers from './stylesScoreRelativeToPeers';
// import EsgMatrix from './esgMatrix';
// import EsgMatrixIndustry from './esgMatrixIndustry';
import BullBearOldBranding from './bullBearOldBranding';
import MultiCompanyBullBearOldBranding from './multiCompanyBullBearOldBranding';
import FinancialsAndIndustryOldBranding from './financialsAndIndustryOldBranding';
import KeyResearchChanges from './keyResearchChanges';

const ESGMateriality = RenditionLoadable({
    loader: () => import('./esgMateriality'),
}, "esgMateriality", Date.now());
const AnalystModel = RenditionLoadable({
    loader: () => import('./analystModel'),
}, "analystModel", Date.now());
const EconomicForecast = ['ECONOMICS FORECAST', 'FX FORECAST', 'COMMODITIES FORECAST'];
const ForecastEntitlement = ['ECONOMIC_FORECAST', 'FX_FORECAST', 'COMMODITIES_FORECAST'];
interface IFinancialsBlockProps {
    source?: any;
    docHeaderSectionJson: any;
    initialData: any;
    multiCompanyMetaData: any;
    styleFactorsData: any;
    menuPaneStatus: string;
    multiStyleFactorCompaniesData: Array<any>;
    restrictionDetailsData: any;
    loadStyleFactorsData: (docId: string, compCode: string, isFAVE: string) => {};
    loadRestrictionDetailsData: (ticker: string) => {};
    fetchUserEntitlements: () => {};
    userEntitlements: any;
    companyCoverageByTicker: any;
    expectedPerformance: any;
    showOldBranding: boolean;
}

export class FinancialsBlock extends Component<IFinancialsBlockProps, any> {
    public HOUSEVIEWS: any;
    public QUANT_STOCK_STYLE: any;
    public REPORTING_CALENDAR: any;
    public FOCUS_LIST: any;
    public KEY_RESEARCH_CHANGES: any;
    public GLOBAL_THEME_MACHINE: any;
    public REQUEST_COMPANY_MODEL: any;
    public REQUEST_CORPORATE_ACCESS: any;
    public CV_MCRO_TOOLS: any;
    public multiStyleFactorCompaniesSendRequestFlag: any = [];
    constructor(props: IFinancialsBlockProps) {
        super(props);
        this.HOUSEVIEWS = React.createRef();
        this.QUANT_STOCK_STYLE = React.createRef();
        this.REPORTING_CALENDAR = React.createRef();
        this.FOCUS_LIST = React.createRef();
        this.KEY_RESEARCH_CHANGES = React.createRef(); 
        this.GLOBAL_THEME_MACHINE = React.createRef();
        this.REQUEST_COMPANY_MODEL = React.createRef();
        this.REQUEST_CORPORATE_ACCESS = React.createRef();
        this.CV_MCRO_TOOLS = React.createRef();
        this.props.fetchUserEntitlements();
        if (props.docHeaderSectionJson.metadata?.companyCode && !window.HTML_RENDITION.isMCN) {
            this.props.loadStyleFactorsData(props.initialData.doc_id, props.docHeaderSectionJson.metadata.companyCode, props.initialData.isFAVE);
            !_.isEmpty(props.docHeaderSectionJson.metadata?.ticker) &&
            !HTML_RENDITION.isHTMLLightRendition() &&
            this.props.loadRestrictionDetailsData(props.docHeaderSectionJson.metadata.ticker);
        }
        if (
            props.docHeaderSectionJson.companyDropdown?.data?.length &&
            !_.isEmpty(props.docHeaderSectionJson.metadata?.ticker) &&
            window.HTML_RENDITION.isMCN &&
            !HTML_RENDITION.isHTMLLightRendition()
        ) {
            let companyCodes = '';
            const companyCodesArr: any = [];
            (props.docHeaderSectionJson.companyDropdown?.data ?? []).map((e: any) => companyCodesArr.push(e.ticker));
            companyCodes = companyCodesArr.join('%2C');
            this.props.loadRestrictionDetailsData(companyCodes);
        }
        this.state = {
            restrictionStatus: false,
            restrictedCompany: '',
            currentCompanyRestrictionDetails: null,
        };
    }

    public showCatalystWatch() {
        const { docHeaderSectionJson, multiCompanyMetaData } = this.props;
        if (!docHeaderSectionJson.CatalystWatch || _.isEmpty(docHeaderSectionJson.CatalystWatch)) {
            return false;
        }
        if (window.HTML_RENDITION.initialData.templateCode == 'CWNote') {
            return false;
        }
        // Test 3439624, when the callType is "REITERATE" we should show the CW link.
        // The callType get from Authoring doc if current doc has CW table. For DC, only has "CLOSE" and "OPEN" status
        if (window.HTML_RENDITION.isMCN) {
            if (_.isEmpty(multiCompanyMetaData)) {
                return;
            }
            const multiCompanyCode = multiCompanyMetaData.companyCode;
            return docHeaderSectionJson.CatalystWatch[multiCompanyCode] && docHeaderSectionJson.CatalystWatch[multiCompanyCode].hasCatalystWatch == 'true'
                && (docHeaderSectionJson.CatalystWatch[multiCompanyCode].callType == 'OPEN' || docHeaderSectionJson.CatalystWatch[multiCompanyCode].callType == 'REITERATE')
                && docHeaderSectionJson.CatalystWatch[multiCompanyCode].isExpired == 'false';
        } else {
            return docHeaderSectionJson.CatalystWatch.hasCatalystWatch == 'true'
                && (docHeaderSectionJson.CatalystWatch.callType == 'OPEN' || docHeaderSectionJson.CatalystWatch.callType == 'REITERATE')
                && docHeaderSectionJson.CatalystWatch.isExpired == 'false';
        }
    }

    public showBullBear() {
        const { docHeaderSectionJson, multiCompanyMetaData } = this.props;
        if (window.HTML_RENDITION.isMCN) {
            if (_.isEmpty(multiCompanyMetaData)) {
                return;
            }
            const multiCompanyCode = multiCompanyMetaData.companyCode;
            return (docHeaderSectionJson.bullBearChart && !_.isEmpty(docHeaderSectionJson.bullBearChart)
                && docHeaderSectionJson.bullBearChart[multiCompanyCode].chartUrl && docHeaderSectionJson.bullBearChart[multiCompanyCode].tableUrl);
        } else {
            return docHeaderSectionJson.bullBearChart && !_.isEmpty(docHeaderSectionJson.bullBearChart)
                && docHeaderSectionJson.bullBearChart.chartUrl && docHeaderSectionJson.bullBearChart.tableUrl;
        }
    }

    public showMenusForMobile() {
        if (deviceTypeFunc() == 'TABLET' || UserAgentUtils.isMobile.any()) {
            return false;
        }
        return true;
    }

    public showHouseView() {
        if (!this.props.initialData.INTERACTIVE_COMPONENTS) return false;
        let flag = false;
        for (let i = 0; i < EconomicForecast.length; i++) {
            if (this.props.initialData.INTERACTIVE_COMPONENTS.toUpperCase().indexOf(EconomicForecast[i]) > -1) {
                flag = true;
                break;
            }
        }
        return flag;
    }
    public checkHouseViewDomEntitlement(dom: any) {
      if (!this.props.initialData.INTERACTIVE_COMPONENTS) return $(dom).hide();
      const allforecastEntitlement = ForecastEntitlement.map((e, index) => {
        let v = false;
        if (this.props.initialData.INTERACTIVE_COMPONENTS.toUpperCase().indexOf(EconomicForecast[index]) > -1) {
           v = true;
        }
        return {key: e, accessable: v};
      });
      const entitlement = allforecastEntitlement.filter((e) => e.accessable);
      const initialData = commonStore.getState().asyncStateReducer.initialData;
      const isEntitled = some(entitlement, ({key}) => initialData.isEntitled(key)); // one component has entitlement ==> house views has entitlement.
      const isAllDeaden = ForecastEntitlement.every((key) => initialData.isDeaden(key)); // all components deaden ==> house views deaden.
      
      const currentEle = $(dom);
      if (!isEntitled && !isAllDeaden) {
        $(currentEle).hide();
        return;
      }
      if (isAllDeaden) {
        currentEle.addClass('deaden');
        const aTag = currentEle.find('a');
        $.each(aTag, (i: number, aTagNode: any) => {
            $(aTagNode).removeAttr('onClick');
            $(aTagNode).css('color','#757575');
        });
      }
      setTimeout(() => {
        if (isAllDeaden) {
            console.log('setting title attr');
            currentEle.removeAttr('title');
        }
    });
    }
    public showStyleAndFactors(isEquitiesCompany: boolean) {
        const { initialData, multiCompanyMetaData, styleFactorsData, multiStyleFactorCompaniesData } = this.props;
        if (!initialData.isEntitled('QUANT_STOCK_STYLE')) {
            return false;
        }
        if (window.HTML_RENDITION.isMCN) {
            if (_.isEmpty(multiCompanyMetaData)) {
                return;
            }
            const multiCompanyCode = multiCompanyMetaData.companyCode;
            if (this.multiStyleFactorCompaniesSendRequestFlag.indexOf(multiCompanyCode) < 0) {
                this.props.loadStyleFactorsData(initialData.doc_id, multiCompanyCode, initialData.isFAVE);
                this.multiStyleFactorCompaniesSendRequestFlag.push(multiCompanyCode);
                return false;
            }

            const companyIndex = multiStyleFactorCompaniesData.indexOf(multiCompanyCode);
            if (companyIndex == -1) {
                return false;
            }
            const companyQuantData = styleFactorsData[companyIndex];
            if (!companyQuantData.charts || companyQuantData.charts.length == 0) {
                return false;
            }
            for (let i = 0; i < companyQuantData.charts.length; i++) {
                if (companyQuantData.charts[i].akamaiLink == '' || companyQuantData.charts[i].title == '') {
                    return false;
                }
            }
            return true;
        } else if (initialData.productType == 'company' || isEquitiesCompany) {
            const charts = styleFactorsData && styleFactorsData[0]?.charts;
            if (charts) {
                for (let i = 0; i < charts.length; i++) {
                    if (charts[i].akamaiLink == '' || charts[i].title == '') {
                        return false;
                    }
                }
            } else {
                return false;
            }
            (document.getElementById('financialsBlock') as any)?.classList.remove('hide');
            return true;
        } else {
            return false;
        }
    }

    public showReportingCalendar() {
        return !HTML_RENDITION.isPreview()
            && this.props.docHeaderSectionJson.issuerPage.financialsBlock.showReportingCalendar;
    }

    public showFocusList() {
        const { initialData, docHeaderSectionJson, multiCompanyMetaData } = this.props;
        const productType = initialData.productType;
        if (['globaliser'].indexOf(productType) > -1 || window.HTML_RENDITION.isRoundup || window.HTML_RENDITION.isPoint || window.HTML_RENDITION.isGlobalizer) {
            return docHeaderSectionJson.metadata.FocusList;
        } else {
            const showFocusList = docHeaderSectionJson.metadata.showFocusList;
            // $scope.shouldShowErrorPopupForFocusList=false; TBD need add in future
            if ((!showFocusList || showFocusList === "false" || showFocusList === "exception") && _.isEmpty(multiCompanyMetaData)) {
                return false;
            }
            if (multiCompanyMetaData){
                return docHeaderSectionJson.metadata[multiCompanyMetaData.companyCode].showFocusList == "true";
            }
            return true;
        }
    }

    public showCompanyModel() {
        return !HTML_RENDITION.isPreview()
            && HTML_RENDITION.parseToBoolean(this.props.docHeaderSectionJson.issuerPage?.financialsBlock?.companyModelFlag?.toLowerCase());
    }

    public showCorporateAccess() {
        return !HTML_RENDITION.isPreview()
            && HTML_RENDITION.parseToBoolean(this.props.docHeaderSectionJson.issuerPage?.financialsBlock?.corporateAccessFlag?.toLowerCase());
    }

    public showSupplyChain() {
        return this.props.docHeaderSectionJson?.issuerPage?.financialsBlock?.showSupplyChain;
    }

    public showCvMacroTools() {
        return !UserAgentUtils.isInsideCVApp.any();
    }

    public checkCurrentCompoentDOMEntit() {
        this.props.showOldBranding && this.HOUSEVIEWS.current && this.checkHouseViewDomEntitlement(this.HOUSEVIEWS.current);
        this.QUANT_STOCK_STYLE.current && checkDomEntitlement(this.QUANT_STOCK_STYLE.current);
        this.REPORTING_CALENDAR.current && checkDomEntitlement(this.REPORTING_CALENDAR.current);
        this.FOCUS_LIST.current && checkDomEntitlement(this.FOCUS_LIST.current);
        this.props.showOldBranding && this.GLOBAL_THEME_MACHINE.current && checkDomEntitlement(this.GLOBAL_THEME_MACHINE.current);
        this.REQUEST_COMPANY_MODEL.current && checkDomEntitlement(this.REQUEST_COMPANY_MODEL.current);
        this.REQUEST_CORPORATE_ACCESS.current && checkDomEntitlement(this.REQUEST_CORPORATE_ACCESS.current);
        this.CV_MCRO_TOOLS.current && checkDomEntitlement(this.CV_MCRO_TOOLS.current);
    }

    public shouldComponentUpdate(nextProps: any, nextState: any) {
        const currentCompanyCode = window.HTML_RENDITION.isMCN ? nextProps.multiCompanyMetaData?.companyCode : this.props.docHeaderSectionJson.metadata.companyCode;
        let companyCodeStr = '';
        if (nextProps.restrictionDetailsData.COVERAGE?.response?.status === "OK" &&
            !_.isEmpty(currentCompanyCode) &&
            this.state.restrictedCompany !== currentCompanyCode
        ) {
            const restrictionArray = nextProps.restrictionDetailsData.COVERAGE?.response?.data?.company.data || [];
            for (const el of restrictionArray) {
                if (el.companyCode === currentCompanyCode) {
                    const currentRestrictionStatus = el?.isRestricted === "true" || !_.isEmpty(el?.continuingRestrictionType);
                    this.setState({
                        restrictionStatus: currentRestrictionStatus,
                        restrictedCompany: el.companyCode,
                        currentCompanyRestrictionDetails: el,
                    });
                    companyCodeStr = el.companyCode;
                    try {
                        const toggleFn = currentRestrictionStatus ? 'hide' : 'show';
                        $(".focuslist-content-container")[toggleFn]();
                        $(".metaDataText")[toggleFn]();
                    } catch (e) {
                        console.log(e, '--change focuslist visible');
                    }
                    break;
                }
            }
        }

        if (this.props.multiCompanyMetaData && nextProps.multiCompanyMetaData
            && nextProps.multiCompanyMetaData.companyCode === this.props.multiCompanyMetaData.companyCode
            && _.isEmpty(nextProps.styleFactorsData) && !_.isEmpty(companyCodeStr)
        ) {
            return false;
        }

        return true;
    }

    public componentDidMount() {
        this.checkCurrentCompoentDOMEntit();
        this.financialsLinkListStyle();
    }

    public financialsLinkListStyle() {
        if ($('#financialsBlock>div .financials a:first:visible').length) {
            $('#financialsBlock').addClass('paddingTopButton15Px');
        } else {
            $('#financialsBlock').removeClass('paddingTopButton15Px');
        }
    }

    public showAnalystModel() {
        const {userEntitlements, companyCoverageByTicker, expectedPerformance} = this.props;
        const analystEntitlement = includes(userEntitlements, 'HTML_PORTLET_EQUITY_FUNDAMENTAL_MODELS');
        const ratingRisk = expectedPerformance?.RatingRisk?.toLowerCase() === 'under review' ? true : false;
        //Means isCR
        const isRestriction = get(companyCoverageByTicker, 'isContinuingRestriction') ==='Y';
        //CRType could be CR1/CR2/CR3
        const crType = get(companyCoverageByTicker, 'continuingRestrictionType');
        //Means isR
        const isR = get(companyCoverageByTicker, 'isRestricted') ==='true';
        const isMaintenanceModelAvailable = get(companyCoverageByTicker,'isMaintenanceModelAvailable') === 'Y';
        const restrictionCondition = (!isR && !isRestriction) || (isR && isRestriction && crType === 'CR1' && isMaintenanceModelAvailable);
        return {
            showAnalystModel: crType !== 'CR3' && analystEntitlement,
            enable: restrictionCondition && !ratingRisk
        };
    }

    public renderDOM() {
        const { initialData, docHeaderSectionJson, showOldBranding } = this.props;
        const productType = initialData.productType;
        const { publishingGroup, productFocus} = docHeaderSectionJson.metadata;
        const isEquitiesCompany = initialData.isFAVE && publishingGroup == 'CIR' && productFocus == 'COMPANY';
        const isEquitiesMultiCompany = initialData.isFAVE && publishingGroup == 'CIR' && productFocus == 'MULTICOMPANY';
        const isFaveCompendium = initialData.isFAVE && productType.toLowerCase() == 'compendium';
        const { currentCompanyRestrictionDetails } = this.state;
        const ASSETTYPE = docHeaderSectionJson.issuerPage.tags.tagsByDCCode?.ASSETTYPE;
        const equityNonFundamentalVals = ['STRATEGY', 'SRI', 'ACCVAL'];
        const isEquityDoc = includes(ASSETTYPE, "EQUITY");
        const isEquityNonFundamentalDoc = some(split(ASSETTYPE, ","), (val) => includes(equityNonFundamentalVals, val)) && isEquityDoc;
        const isCR3 = currentCompanyRestrictionDetails?.continuingRestrictionType === 'CR3';
        const showAnalystModelComp = !isEquityNonFundamentalDoc && this.showAnalystModel().showAnalystModel && (['company', 'multicompany'].indexOf(productType) > -1 || isEquitiesCompany || isEquitiesMultiCompany);
        const internalPlatformIds = split(window.HTML_RENDITION.initialData.internalPlatformIds,",");
        const isExternalUser = !includes(internalPlatformIds, window.HTML_RENDITION.initialData.platform);
        return (
            <>
                {!showOldBranding && <React.Fragment>
                {this.showMenusForMobile() &&
                    <div id="requestSupplyChain">
                        {this.showSupplyChain() && <SupplyChain showOldBranding={showOldBranding}/>}
                    </div>
                }
                {!isEquityNonFundamentalDoc && ((productType == 'multicompany' || isEquitiesMultiCompany) && this.showCatalystWatch()) && !this.state.restrictionStatus &&
                    <div id="requestCatalystWatch" >
                        <ErrorBoundary><MultiCompanyCatalystWatch /></ErrorBoundary>
                    </div>
                }
                {/* Removing Catalyst Watch for Company */}
                {/* {(['company', 'anr', 'credit'].indexOf(productType) > -1 || isEquitiesCompany) && this.showCatalystWatch() && !this.state.restrictionStatus &&
                    <div id="requestCatalystWatch" >
                        <ErrorBoundary><CatalystWatch /></ErrorBoundary>
                    </div>
                } */}
                {/* If is Static Mode should use normal bullBear logic */}
                {!isEquityNonFundamentalDoc && ['EMA', 'FI'].indexOf(publishingGroup) === -1 && (productType == 'multicompany' || isEquitiesMultiCompany) && !HTML_RENDITION.isStaticMode() && !this.state.restrictionStatus &&
                    (<div id="requestBullBear">
                        <ErrorBoundary><MultiCompanyBullBear /></ErrorBoundary>
                    </div>)
                }
                {/* If is Static Mode should use normal bullBear logic */}
                {/* Showing BullBear only for Company Flash Reports(where templateCode is "Discontinuation") */}
                {!isEquityNonFundamentalDoc && (_.toLower(window.HTML_RENDITION.initialData.productFocus) === "company" || isEquitiesCompany) &&
                    (<div id="requestBullBear">
                        <ErrorBoundary><BullBear /></ErrorBoundary>
                    </div>)
                }
                <div className='financials-analyst'>
                {!isEquityNonFundamentalDoc && (['company', 'multicompany'].indexOf(productType) > -1 || isEquitiesCompany || isEquitiesMultiCompany) &&
                    <ErrorBoundary><FinancialsAndIndustry showOldBranding={showOldBranding} showAnalystModelComp={showAnalystModelComp} restrictionStatus={this.state.restrictionStatus} /></ErrorBoundary>
                }
                {showAnalystModelComp && <AnalystModel multiCompanyMetaData={this.props.multiCompanyMetaData} disabled={!this.showAnalystModel().enable} />}
                </div>
                {/* Added this empty div to enable clickthru.json to capture price-chart rendering */}
                <div id="financials-price-chart" />

                {this.props.initialData.isEntitled('FIGURE_GALLERY') &&
                    <React.Fragment>
                        {/* Added this empty div to enable clickthru.json to capture figure-gallery expand & collapse rendering */}
                        <div id="financials-figure-gallery-ex-col" />   {/* entitlement componentname="FIGURE_GALLERY" */}
                        {/* Added this empty div to enable clickthru.json to capture figure-gallery rendering */}
                        <div id="financials-figure-gallery" />          {/* entitlement componentname="FIGURE_GALLERY" */}
                    </React.Fragment>
                }
                {window.HTML_RENDITION.isPoint &&
                    <ErrorBoundary><PointFinancialsBlock /></ErrorBoundary>
                }
                {/* implemented Analyst Model instead of Company Model */}
                {/* {(!window.HTML_RENDITION.isPoint || isEquitiesCompany || isEquitiesMultiCompany) && this.showCompanyModel() &&
                    <div id="requestCompanyModel" data-entitlement="REQUEST_COMPANY_MODEL" ref={this.REQUEST_COMPANY_MODEL}>
                        <ErrorBoundary><CompanyModel pop={false}/></ErrorBoundary>
                    </div>
                } */}
                {!isEquityNonFundamentalDoc && (['company', 'multicompany'].indexOf(productType) > -1 || isEquitiesCompany || isEquitiesMultiCompany) &&
                    <div id="requestCompanyDashboard" data-entitlement="REQUEST_COMPANY_DASHBOARD">
                        <ErrorBoundary><CompanyDashboard isExternalUser={isExternalUser}/></ErrorBoundary>
                    </div>
                }
                {/* {!isEquityNonFundamentalDoc && (['company', 'multicompany'].indexOf(productType) > -1 || isEquitiesCompany || isEquitiesMultiCompany) &&
                    this.showStyleAndFactors(isEquitiesCompany) && this.props.styleFactorsData &&
                    !this.state.restrictionStatus &&
                    <div id="styleAndFactors" data-entitlement="QUANT_STOCK_STYLE" ref={this.QUANT_STOCK_STYLE}>
                        <ErrorBoundary><StyleAndFactors propsCallback={this.financialsLinkListStyle} showOldBranding={showOldBranding}/></ErrorBoundary>
                    </div>
                } */}
                {!isEquityNonFundamentalDoc && (['company', 'multicompany'].indexOf(productType) > -1 || isEquitiesCompany || isEquitiesMultiCompany) &&
                    <div id="requestStylesScoreRelativeToPeers" data-entitlement="REQUEST_STYLES_SCORE_RELATIVE_TO_PEERS">
                        <ErrorBoundary><StylesScoreRelativeToPeers /></ErrorBoundary>
                    </div>
                }
                {/* {!window.HTML_RENDITION.isPoint && this.showCorporateAccess() &&
                    <div id="requestCorporateAccess" data-entitlement="REQUEST_CORPORATE_ACCESS" ref={this.REQUEST_CORPORATE_ACCESS}>
                        <ErrorBoundary><CorporateAccess pop={false}/></ErrorBoundary>
                    </div>
                } */}
                {window.HTML_RENDITION.isPoint &&                                   // per C150113-88329, the Key Research Changes should be available for Point products
                    <div id="requestKeyResearchChanges" ref={this.KEY_RESEARCH_CHANGES}>
                        <ErrorBoundary><KeyResearchChanges isExternalUser={isExternalUser}/></ErrorBoundary>
                    </div>                
                }
                {
                    <div id="requestGlobalThemeMachine" data-entitlement="GLOBAL_THEME_MACHINE_1369" ref={this.GLOBAL_THEME_MACHINE}>
                        <ErrorBoundary><GlobalThemeMachine isExternalUser={isExternalUser}/></ErrorBoundary>
                    </div>
                }
                {!isEquityNonFundamentalDoc && this.showCvMacroTools() &&                         // per C150113-37255, the MacroTools should be available for any products
                    <div className="cvMacroTools" id="cvMacro_Tools" data-entitlement="CV_MCRO_TOOLS" ref={this.CV_MCRO_TOOLS} >
                        <ErrorBoundary><CvMacroTools propsCallback={this.financialsLinkListStyle} isExternalUser={isExternalUser}/></ErrorBoundary>
                    </div>
                }
                {/* ESG Matrix is retired */}
                {/* {!isExternalUser && !isEquityNonFundamentalDoc && (isEquitiesCompany || isEquitiesMultiCompany) &&
                    <ErrorBoundary><EsgMatrix /></ErrorBoundary>
                }
                {!isEquityNonFundamentalDoc && productFocus === 'INDUSTRY' && ['Audio', 'Video', 'Note', 'Report', 'Presentation'].indexOf(window.HTML_RENDITION.initialData.templateCode) > -1 && productFocus !== "DISCIPLINE" &&
                    <ErrorBoundary><EsgMatrixIndustry isExternalUser={isExternalUser}/></ErrorBoundary>
                } */}
                {/* {((!HTML_RENDITION.isStaticMode() && !window.HTML_RENDITION.initialData.isStaticHtml &&
                   !this.state.restrictionStatus &&
                   !window.HTML_RENDITION.initialData.isStaticHtmlExport) &&
                   (isEquitiesCompany || isEquitiesMultiCompany)) &&
                    <ErrorBoundary><ESGMateriality /></ErrorBoundary>
                } */}
                {/* {this.showFocusList() && (isFaveCompendium || !initialData.isFAVE || isEquitiesCompany || isEquitiesMultiCompany) && !this.state.restrictionStatus && */}
                {
                    <div id="requestFocusList" data-entitlement="FOCUS_LIST" ref={this.FOCUS_LIST}>
                        <FocusList isExternalUser={isExternalUser}/>
                    </div>
                }
                {
                    // {this.showMenusForMobile() && <div id="houseViews" ref={this.HOUSEVIEWS}>{this.showHouseView() && <HouseViews />}</div>}
                    <div id="houseViews" ref={this.HOUSEVIEWS}>
                        <HouseViews isExternalUser={isExternalUser}/>
                    </div>
                }
            </React.Fragment>}
            {showOldBranding && <React.Fragment>
                    {this.showMenusForMobile() &&
                    <div id="requestSupplyChain">
                        {this.showSupplyChain() && <SupplyChain showOldBranding={showOldBranding}/>}
                    </div>
                }
                {((productType == 'multicompany' || isEquitiesMultiCompany) && this.showCatalystWatch()) && !this.state.restrictionStatus &&
                    <div id="requestCatalystWatch" >
                        <ErrorBoundary><MultiCompanyCatalystWatch /></ErrorBoundary>
                    </div>
                }
                {(['company', 'anr', 'credit'].indexOf(productType) > -1 || isEquitiesCompany) && this.showCatalystWatch() && !this.state.restrictionStatus &&
                    <div id="requestCatalystWatch" >
                        <ErrorBoundary><CatalystWatch /></ErrorBoundary>
                    </div>
                }
                {/* If is Static Mode should use normal bullBear logic */}
                {(productType == 'multicompany' || isEquitiesMultiCompany) && !HTML_RENDITION.isStaticMode() && this.showBullBear() && !this.state.restrictionStatus &&
                    (<div id="requestBullBear">
                        <ErrorBoundary><MultiCompanyBullBearOldBranding /></ErrorBoundary>
                    </div>)
                }
                {/* If is Static Mode should use normal bullBear logic */}
                {(['company', 'anr', 'credit'].indexOf(productType) > -1 || isEquitiesCompany) && this.showBullBear() && !this.state.restrictionStatus &&
                    (<div id="">
                        <ErrorBoundary><BullBearOldBranding /></ErrorBoundary>
                    </div>)
                }
                {initialData.showDiv('MULTI_TAB_STATAB_FINSUM', 'INDUSTRY_COMPARABLES') && !isCR3 &&
                    <ErrorBoundary><FinancialsAndIndustryOldBranding showOldBranding={showOldBranding} restrictionStatus={this.state.restrictionStatus} /></ErrorBoundary>
                }
                {/* Added this empty div to enable clickthru.json to capture price-chart rendering */}
                <div id="financials-price-chart" />

                {this.props.initialData.isEntitled('FIGURE_GALLERY') &&
                    <React.Fragment>
                        {/* Added this empty div to enable clickthru.json to capture figure-gallery expand & collapse rendering */}
                        <div id="financials-figure-gallery-ex-col" />   {/* entitlement componentname="FIGURE_GALLERY" */}
                        {/* Added this empty div to enable clickthru.json to capture figure-gallery rendering */}
                        <div id="financials-figure-gallery" />          {/* entitlement componentname="FIGURE_GALLERY" */}
                    </React.Fragment>
                }

                {((!HTML_RENDITION.isStaticMode() && !window.HTML_RENDITION.initialData.isStaticHtml &&
                   !this.state.restrictionStatus &&
                   !window.HTML_RENDITION.initialData.isStaticHtmlExport) &&
                   (isEquitiesCompany || isEquitiesMultiCompany)) &&
                    <ErrorBoundary><ESGMateriality /></ErrorBoundary>
                }

                {window.HTML_RENDITION.isPoint &&
                    <ErrorBoundary><PointFinancialsBlock /></ErrorBoundary>
                }
                {/* {this.showMenusForMobile() && <div id="houseViews" ref={this.HOUSEVIEWS}>{this.showHouseView() && <HouseViews />}</div>} */}
                {(['company', 'multicompany'].indexOf(productType) > -1 || isEquitiesCompany || isEquitiesMultiCompany) &&
                    this.showStyleAndFactors(isEquitiesCompany) && this.props.styleFactorsData &&
                    !this.state.restrictionStatus &&
                    <div id="styleAndFactors" data-entitlement="QUANT_STOCK_STYLE" ref={this.QUANT_STOCK_STYLE}>
                        <ErrorBoundary><StyleAndFactors propsCallback={this.financialsLinkListStyle}/></ErrorBoundary>
                    </div>
                }
                {!window.HTML_RENDITION.isPoint && this.showReportingCalendar() &&
                  this.showMenusForMobile() &&
                    <div id="reportingCalenderContainer" data-entitlement="REPORTING_CALENDAR" ref={this.REPORTING_CALENDAR}>
                        <ReportingCalendar />
                    </div>
                }
                {this.showFocusList() && (isFaveCompendium || !initialData.isFAVE || isEquitiesCompany || isEquitiesMultiCompany) && !this.state.restrictionStatus &&
                    <div id="requestFocusList" data-entitlement="FOCUS_LIST" ref={this.FOCUS_LIST}>
                        <FocusList />
                    </div>
                }
                {(!window.HTML_RENDITION.isPoint || isEquitiesCompany || isEquitiesMultiCompany) && this.showCompanyModel() &&
                    <div id="requestCompanyModel" data-entitlement="REQUEST_COMPANY_MODEL" ref={this.REQUEST_COMPANY_MODEL}>
                        <ErrorBoundary><CompanyModel pop={false}/></ErrorBoundary>
                    </div>
                }
                {!window.HTML_RENDITION.isPoint && this.showCorporateAccess() &&
                    <div id="requestCorporateAccess" data-entitlement="REQUEST_CORPORATE_ACCESS" ref={this.REQUEST_CORPORATE_ACCESS}>
                        <ErrorBoundary><CorporateAccess pop={false} showOldBranding={showOldBranding} /></ErrorBoundary>
                    </div>
                }
                {this.showCvMacroTools() &&        // per C150113-37255, the MacroTools should be available for any products
                    <div className="cvMacroTools" id="cvMacro_Tools" data-entitlement="CV_MCRO_TOOLS" ref={this.CV_MCRO_TOOLS} >
                        <ErrorBoundary><CvMacroTools propsCallback={this.financialsLinkListStyle}/></ErrorBoundary>
                    </div>
                }
                </React.Fragment>}
            </>
        );
    }

    public render() {
        const { initialData, multiCompanyMetaData } = this.props;
        if (this.props.menuPaneStatus == 'infoTabButton') { // in mobile, we don't have the financial block in RHS, so need to use the ifShowFinancialBlock function to decide if showing this block
            this.financialsLinkListStyle();
        }
        if (window.HTML_RENDITION.isMCN && multiCompanyMetaData) {
            setTimeout(() => {
                this.checkCurrentCompoentDOMEntit();
            });
            return this.renderDOM();
        } else if (initialData.productType != 'multicompany') {
            return this.renderDOM();
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        restrictionDetailsData: state.asyncStateReducer.restrictionDetailsData,
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
        multiCompanyMetaData: state.commonStateReducer.multiCompanyMetaData,
        multiStyleFactorCompaniesData: state.asyncStateReducer.multiStyleFactorCompanies,
        styleFactorsData: state.asyncStateReducer.styleFactorsData,
        menuPaneStatus: state.commonStateReducer.menuPaneStatus,
        userEntitlements: state.asyncStateReducer.userEntitlements,
        companyCoverageByTicker: state.asyncStateReducer.companyCoverageByTicker,
        expectedPerformance: state.asyncStateReducer.expectedPerformance,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        loadStyleFactorsData: (docId: string, compCode: string, isFAVE: string) =>
            dispatch(asyncStateAction.fetchStyleFactors(Object.assign(servicesConfig.GET_STYLE_FACTORS, {
                'url_parameter': [
                    'docId=' + docId,
                    'companyCode=' + compCode,
                    'isFAVE=' + isFAVE
                ]
        }))),
        loadRestrictionDetailsData: (ticker: string) =>
            dispatch(asyncStateAction.fetchRestrictionDetails(Object.assign(servicesConfig.GET_RESTRICTION_DETAILS, {
                'url_parameter': [
                    'ticker=' + ticker
                ]
        }))),
        fetchUserEntitlements: () => dispatch(asyncStateAction.fetchUserEntitlements(Object.assign(servicesConfig.GET_USER_ENTITLEMENTS))),
        };
};

export default connect(mapStateToProps, mapDispatchToProps)(FinancialsBlock);
